import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente de datos de ÁGORA. Los talleres presenciales viven en redes
 * inestables: reintentos moderados y datos considerados frescos por 30 s
 * para no golpear la API (127.0.0.1:8020) en cada foco de ventana.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
